export const AppRegexRegisteredRoutes = [
    /\/login\b/,
    /\/home\b/,
    /\/inventarios\b/,
    /\/inventarios\/productos\b/,
    /\//
];